<dx-popup
  [width]="'90%'"
  [maxWidth]="620"
  [height]="popupHeight"
  [showTitle]="true"
  [title]="'MY-INVITATION.LOGIN' | translate"
  [dragEnabled]="false"
  [hideOnOutsideClick]="false"
  [showCloseButton]="true"
  class="modal"
  [classList]="'modal'"
  [visible]="showModal"
  (onHidden)="closeModal()"
  (onHiding)="onPopupHiding()"
>
  <div *dxTemplate="let data of 'content'">
    <div
      [hidden]="isShowForm || isFormSubmitted || isRequestFormSubmitted"
      class="login-options"
    >
      <div>
        <dx-button
          [text]="'MY-INVITATION.LOGIN-EMPLOYEE' | translate"
          type="normal"
          (click)="training!.status == 2 ? navigateTrainingWaitList() : navigateTraining()"
        ></dx-button>
      </div>
      <div class="separator">
        {{ "MY-INVITATION.OR" | translate }}
      </div>
      <div>
        <dx-button
          [text]="'MY-INVITATION.CONTINUE-GUEST' | translate"
          type="normal"
          (click)="showForm()"
        ></dx-button>
      </div>
    </div>
    <div
      [hidden]="
        !isShowForm || (isShowForm && isFormSubmitted) || isRequestFormSubmitted
      "
    >
      <dx-scroll-view
        [height]="'auto'"
        [useNative]="true"
        [showScrollbar]="'always'"
        class="questions-scroll"
      >
        <div>
          <dx-form #form [formData]="formData" labelMode="floating">

            <ng-container *ngFor="let field of registrationFieldConfigs">
              <dxi-item
                *ngIf="field.visible"
                [dataField]="field.key"
              >
                <dxo-label 
                  [text]="getLabelKey(field.key) | translate"
                ></dxo-label>
                <dxi-validation-rule
                  *ngIf="field.required"
                  type="required"
                  [message]="getRequiredMessageKey(field.key) | translate">
                </dxi-validation-rule>
                <dxi-validation-rule
                  *ngIf="field.key === emailKey"
                  type="email"
                  [message]="'VALIDATIONS.EMAIL-INVALID' | translate"
                ></dxi-validation-rule>
              </dxi-item>
            </ng-container>
          </dx-form>
        </div>
        <div 
          *ngIf="questions && questions.length !== 0"
          class="questions-container" 
        >
          <app-answer-training-questions-dialog
            [remainingParticipantSlots]="remainingParticipantSlots"
            [questions]="questions"
          ></app-answer-training-questions-dialog>
        </div>
      </dx-scroll-view>
      <div class="terms">
        <dx-check-box
          #checkbox
          [(value)]="isTermsAccepted"
        ></dx-check-box>

        <label class="terms-label" (click)="toggleCheckbox(checkbox)">
          {{ 'MY-INVITATION.TERMS' | translate }}
          <span class="required"> *</span>
        </label>
      </div>      
      <div class="form-cta">
        <dx-button
          [ngStyle]="{'visibility': training!.guestsOnly ? 'hidden' : 'visible'}"
          [text]="'COMMON.BACK' | translate"
          type="default"
          (click)="onBackClick()"
        ></dx-button>
        <dx-button
          [disabled]="!isTermsAccepted"
          [text]="'MY-INVITATION.SEND' | translate"
          type="normal"
          (click)="training!.status == 2 ? addToQueue() : acceptInvitation()"
        ></dx-button>
      </div>
    </div>
    <div [hidden]="!isFormSubmitted" class="response-message">
      @if(isAddedToQueue) {
        <div class="text-center">
          {{ "MY-INVITATION.ADDED-TO-QUEUE-MESSAGE" | translate }}
        </div>
      } @else {
        <div *ngIf="!personNotFound">
          {{ "MY-INVITATION.SUBMIT-SUCCESS-MESSAGE" | translate }}
        </div>
        <div *ngIf="personNotFound">
          {{ "MY-INVITATION.PERSON-NOT-FOUND" | translate }}
        </div>
      }
     
      <div class="response-cta">
        @if(personNotFound){
          <dx-button
            class="order-2 order-sm-1"
            [text]="'COMMON.CANCEL' | translate"
            type="default"
            (click)="cancelError()"
          ></dx-button>
          <dx-button
            [text]="'COMMON.REQUEST-PARTICIPATION' | translate"
            class="order-1 order-sm-2"
            type="normal"
            (click)="sendRequest()"
          ></dx-button>
        } @else {
          <dx-button
            [text]="'COMMON.CLOSE' | translate"
            type="normal"
            (click)="closeModal()"
          ></dx-button>
        }
      </div>
    </div>
    <div [hidden]="!isRequestFormSubmitted" class="response-message">
      <div>
        {{ "MY-INVITATION.REQUEST-SUCCESS-MESSAGE" | translate }}
      </div>
      <div class="response-cta">
        <dx-button
          [text]="'COMMON.CLOSE' | translate"
          type="normal"
          (click)="closeModal()"
        ></dx-button>
      </div>
    </div>
  </div>
</dx-popup>

<app-training-waiting-list-modal
  [showModal]="showTrainingWaitingListModal"
  (onSend)="onAddToQueue()"
  (onCancel)="onAddToQueueClose()"
></app-training-waiting-list-modal>
